module.exports = __webpack_public_path__ + "img/PS11.c5a903b9.png";